import {
  Box,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { formatPercent, getColor } from './utils';

const TicketsStatsTable = ({ filteredStats }) => {
  if (!filteredStats.length) {
    return (
      <Grid size={12}>
        <Paper sx={{ p: 2 }}>
          <Typography variant="body1">
            Aucune statistique disponible pour la période sélectionnée.
          </Typography>
        </Paper>
      </Grid>
    );
  }
  const sortedStats = [...filteredStats].sort((a, b) => {
    const [yearA, monthA] = a.month.split('-').map(Number);
    const [yearB, monthB] = b.month.split('-').map(Number);
    return yearB !== yearA ? yearB - yearA : monthB - monthA;
  });

  return (
    <Grid size={12}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6" mb={2}>
          Comparaison par Mois et Service
        </Typography>
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer component={Box}>
            <Table
              size="small"
              aria-label="Statistiques des tickets par mois et service"
            >
              <TableHead>
                <TableRow>
                  <TableCell colSpan={2}>
                    <Divider
                      textAlign="left"
                      sx={{ my: 1, fontWeight: 'bold' }}
                    >
                      Mois & Service
                    </Divider>
                  </TableCell>
                  <TableCell colSpan={1}>
                    <Divider
                      textAlign="left"
                      sx={{ my: 1, fontWeight: 'bold' }}
                    >
                      Créés
                    </Divider>
                  </TableCell>
                  <TableCell colSpan={3}>
                    <Divider
                      textAlign="left"
                      sx={{ my: 1, fontWeight: 'bold' }}
                    >
                      Traités
                    </Divider>
                  </TableCell>
                  <TableCell colSpan={3}>
                    <Divider
                      textAlign="left"
                      sx={{ my: 1, fontWeight: 'bold' }}
                    >
                      Fermés
                    </Divider>
                  </TableCell>
                  <TableCell colSpan={2}>
                    <Divider
                      textAlign="left"
                      sx={{ my: 1, fontWeight: 'bold' }}
                    >
                      Période
                    </Divider>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell scope="col" align="center">
                    Mois
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Service
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Total Créés
                  </TableCell>
                  <TableCell scope="col" align="center">
                    À Traiter
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Traités
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Taux de Traitement
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Ouverts
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Fermés
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Taux Fermeture
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Traités sur la période
                  </TableCell>
                  <TableCell scope="col" align="center">
                    Taux d&apos;Absorption
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedStats.map((stat) => {
                  const treatedRate =
                    (stat.ticketsTreated / stat.totalTickets) * 100 || 0;
                  const closedRate =
                    (stat.ticketsClosed / stat.totalTickets) * 100 || 0;
                  const absorptionRate =
                    (stat.totalProcessedInPeriod / stat.totalTickets) * 100 ||
                    0;

                  return (
                    <TableRow key={`${stat.month}-${stat.serviceCode}`} hover>
                      <TableCell align="center">{stat.month}</TableCell>
                      <TableCell align="center">{stat.serviceCode}</TableCell>
                      <TableCell align="center">{stat.totalTickets}</TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: getColor(stat.toTreat, 'toTreat') }}
                      >
                        {stat.toTreat}
                      </TableCell>
                      <TableCell align="center">
                        {stat.ticketsTreated}
                      </TableCell>
                      <TableCell align="center">
                        {formatPercent(treatedRate)}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: getColor(stat.opened, 'opened') }}
                      >
                        {stat.opened}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: getColor(stat.ticketsClosed, 'closed'),
                        }}
                      >
                        {stat.ticketsClosed}
                      </TableCell>
                      <TableCell align="center">
                        {formatPercent(closedRate)}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: getColor(
                            stat.totalProcessedInPeriod,
                            'totalProcessedInPeriod'
                          ),
                        }}
                      >
                        {stat.totalProcessedInPeriod}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          color: getColor(absorptionRate, 'absorptionRate'),
                        }}
                      >
                        {formatPercent(absorptionRate)}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
    </Grid>
  );
};

export default TicketsStatsTable;
